import React, { useEffect, useState } from "react";
import { Form, Offcanvas, Button } from "react-bootstrap";
import { blogSubCategoryServices } from "../../../../APIServices/SitePilotManagement/BlogManagement/blogSubCategoryServices";

const AddSubCategory = ({ show, hide, title, getBlogSubCategoryList, blogCategories }) => {
  const [name, setName] = useState("");
  const [categoryId, setCategoryId] = useState("");
  const [loader, setLoader] = useState(false);

  const addNewBlogSubCategory = async () => {
    setLoader(true)
    let userData = {}
    userData.categoryId = categoryId
    userData.name = name
    let data = await blogSubCategoryServices.addNewBlogSubCategory(userData)
    if (data?.statusCode === 200) {
      getBlogSubCategoryList()
      clearData();
    }
    setLoader(false)
  }

  const clearData = () => {
    setName("");
    setCategoryId("");
    setLoader(false)
    hide();
  }

  useEffect(() => {
    if (!show) {
      setName("");
      setCategoryId("");
      setLoader(false)
    }
  }, [show]);

  return (
    <Offcanvas show={show} onHide={hide} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{title}</Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body>
        <Form>
          <Form.Group className="mb-2">
            <Form.Label>Category</Form.Label>
            <Form.Select
              name="category"
              value={categoryId}
              onChange={(e) => setCategoryId(e.target.value)}
            >
              <option value="">Select Category</option>
              {blogCategories?.map(item => (
                <option value={item?.categoryId}>{item?.name}</option>
              ))}
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-2">
            <Form.Label>
              Name <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              name="userName"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Enter Name"
            />
          </Form.Group>
          <div className="d-flex justify-content-end gap-2 mt-3">
            <Button onClick={clearData} style={{ fontSize: 12 }} variant="light" >
              Cancel
            </Button>
            <Button
              disabled={!name || !categoryId || loader}
              onClick={addNewBlogSubCategory}
              style={{ fontSize: 12 }}>
              {title}
            </Button>
          </div>
        </Form>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default AddSubCategory;
